import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layoutthree";
import bgError from "../images/404.svg";
import { BtnPrimary } from "../components/buttons/BtnPrimary";

export const NotFound = () => {
  return (
  <Layout>
    <Helmet title="Error" />
      <div className="error">
       
        <div className="error-content">
          <h1 className="oops">Oops!</h1>
          <p>The page you are looking for does not exist. You can return to the home page from here.</p>
          <BtnPrimary
                    link="/"
                    btnText="Go to homepage"
                  />
        </div>
      </div>
  </Layout>

  );
};

export default NotFound;
